module.exports = __webpack_public_path__ + "img/guyana.4cec5075.svg";